import React, { useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { apiUrl } from '../../../config';
import apiService from '../../../utlis/apiService';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { useUser } from '../../../context/userContext';

export default function HdfcPaymentReport() {
    const { permissions } = useUser();
    const [data, setData] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });
    const [filterData, setFilterData] = useState({
        dateFrom: null,
        dateTo: null,
        type: '',
    });
    const [loading, setLoading] = useState(false);

    const pageOption = [10, 25, 50, 100];

    useEffect(() => {
        getPaymentData();
    },[filterData, paginationModel]);

    const getPaymentData = async() => {
        setLoading(true);
        try {
            const paymentResponse = await apiService.get('/report/hdfc-payment', {
                params: {
                    ...filterData,
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                },
            });

            setData(paymentResponse?.data?.report);
            setTotalResults(paymentResponse?.data?.totalResults);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const exportReport = async () => {
        try {
            const response = await apiService.get('/export/report/hdfc-payment', {
                params: {
                    ...filterData,
                },
            });

            if(response?.data?.status === 'success') {
                
                window.open(`${apiUrl}${response?.data?.path}`, '_blank');
            }
        }
        catch (error) {
            console.error(error);
        }
    }


    const handleChange = (name, value) => {
        setFilterData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };

    const CustomName = (row) => {
        const currentRow = row.value;
        let name = '';
        if(currentRow.recordingsAdmission) {
            name = currentRow.recordingsAdmission.firstName + ' ' + currentRow.recordingsAdmission.lastName;
        }
        else {
            name = currentRow.student.firstName + ' ' + currentRow.student.lastName;
        }
        
        return name;
    }

    const CustomEmail = (row) => {
        const currentRow = row.value;
        let name = '';
        if(currentRow.recordingsAdmission) {
            name = currentRow.recordingsAdmission.email;
        }
        else {
            name = currentRow.student.email;
        }
        
        return name;
    }

    const CustomPhone = (row) => {
        const currentRow = row.value;
        let name = '';
        if(currentRow.recordingsAdmission) {
            name = currentRow.recordingsAdmission.phoneNumber;
        }
        else {
            name = currentRow.student.phoneNumber;
        }
        
        return name;
    }

    const CustomeStatusType = (row) => {
        const currentRow = row.value;
        let name = '';
        if(currentRow.recordingsAdmission) {
            name = currentRow.statusType;
        }
        else {
            const admission = currentRow.admission;
            const category = admission.category.find(category => category._id === currentRow.categoryObjectId);

            name = category?.statusType;
        }
        
        return name;
    }

    return (
        <div style={{ height: '75vh', width: '100%' }}>
            <Typography variant="h4" gutterBottom>
                HDFC RECEIVED REPORT
            </Typography>
            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 5 }}>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                        <FormControl className='gap-2 mb-8' fullWidth>
                            <MobileDatePicker
                                label="Date From"
                                value={filterData.dateFrom}
                                onChange={(date) => handleChange('dateFrom', date)}
                                sx={{ marginTop: 1 }}
                                format="DD/MM/YYYY"
                                slotProps={{
                                    actionBar: {
                                      actions: ['clear', 'cancel', 'accept'],
                                    },
                                    textField: {
                                        size: 'small'
                                    }
                                }}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                        <FormControl className='gap-2 mb-8' fullWidth>
                            <MobileDatePicker
                                label="Date To"
                                value={filterData.dateTo}
                                onChange={(date) => handleChange('dateTo', date)}
                                sx={{ marginTop: 1 }}
                                format="DD/MM/YYYY"
                                slotProps={{
                                    actionBar: {
                                      actions: ['clear', 'cancel', 'accept'],
                                    },
                                    textField: {
                                        size: 'small'
                                    }
                                }}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                    <FormControl fullWidth sx={{ marginTop: '10px' }} size="small">
                        <InputLabel id="Status">Type</InputLabel>
                        <Select
                            label="Type"
                            value={filterData.status}
                            onChange={(e) => handleChange('type', e.target.value)}
                            fullWidth
                            name="type"
                            size="small"
                        >
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="admission">Admission</MenuItem>
                            <MenuItem value="recordings">Recordings</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 3 }}>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={8}>
                    <Button variant="outlined" size='small' sx={{ float: 'right' }} title="Export" onClick={exportReport}><DownloadIcon /></Button>
                </Grid>
            </Grid>
            
            {loading ? (
                <div style={{ textAlign: 'center' }}>
                    <CircularProgress style={{ margin: 'auto' }} />
                </div>

            ) : (
                <DataGridPro
                    getRowId={(row) => row._id}
                    rows={data}
                    disableDensitySelector
                    columns={[
                        {
                            field: 'createdAt', 
                            headerName: 'Date', 
                            width: 150, 
                            valueFormatter: (params) => new Date(params.value).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })
                        },
                        { field: 'name', headerName: 'Name', flex: 1, renderCell: (params) => <CustomName value={params?.row} /> },
                        { field: 'email', headerName: 'Email', flex: 1, renderCell: (params) => <CustomEmail value={params?.row} /> },
                        { field: 'phone', headerName: 'Phone', flex: 1, renderCell: (params) => <CustomPhone value={params?.row} /> },
                        { field: 'amount', headerName: 'Amount', flex: 1 },
                        { field: 'type', headerName: 'Type', flex: 1, valueGetter: (params) => params?.row?.recordingsAdmission ? 'Recordings' : 'Admission' },
                        { field: 'course', headerName: 'Course', flex: 1, valueGetter: (params) => params?.row?.course?.name },
                        { field: 'category', headerName: 'Category', flex: 1, valueGetter: (params) => params?.row?.category?.name },
                        { field: 'statusType', headerName: 'Status Type', flex: 1, renderCell: (params) => <CustomeStatusType value={params?.row} /> },
                        { field: 'transaction', headerName: 'Transaction Id', flex: 1 },
                    
                    ]}
                    pagination
                    paginationModel={paginationModel}
                    rowCount={totalResults}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={pageOption} 
                />
            )}
        </div>
    );
}
